const favoritesConstants = {
  GET_VALUE: 'GET_VALUE',
};

export default favoritesConstants;